import React from 'react';

const UserAvatar = ({ isOnline = false, bgColor = "#344969" }) => (
  <div className={`avatar`}>
    <div 
      className="d-flex align-items-center justify-content-center rounded-circle text-white"
      style={{ 
        backgroundColor: bgColor,
        width: '38px', 
        height: '38px'
      }}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="22" 
        height="22" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </div>
  </div>
);

export default UserAvatar;